/* eslint-disable array-callback-return */
// third-party
import { createSlice } from '@reduxjs/toolkit';
import { filterQueryString } from 'helpers/objectFunctions';

// project imports
import axios from 'utils/axios';
import { dispatch } from '../index';
// import { authHardcodedToken } from 'store/constant';
import { ARYABHATTA_API_DOMAIN_V1 } from 'config';
import { DEFAULT_ERROR_MESSAGE } from '../constant';
import { devConsolelog } from 'helpers/utilityFunctions';
import { openSnackbar } from './snackbar';

// ----------------------------------------------------------------------

const initialState = {
    error: null,
    data: {},
    memData: {},
    autoSuggestData: {
        dropdownData: []
    },
    selectedTicketData: {},
    postTicketData: {
        organization: null,
        category: 1,
        member: null,
        request_type: 3,
        request_description_or_state: '',
        request_type_code: '',
        assigned_to: null
    },
    isLoading: false,
    filters: {
        // assigned_to: [{ id: true, name: true }]
    }
};

const slice = createSlice({
    name: 'ticketsList',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
        },

        // setData
        setData(state, action) {
            const { count = 0, next = null, previous = null, results = {}, page = 0 } = action.payload;
            const { utilities = {}, open_close_system: ticketsList = [] } = results || {};
            const { filters = [] } = utilities || {};
            devConsolelog('category data', filters[2]);
            state.data.count = count;
            state.data.next = next;
            state.data.previous = previous;
            state.data.utilities = utilities;
            state.data.ticketsList = ticketsList;
            state.data.currentPage = page;
            state.data.staticDropdownData = filters;
        },

        // setData
        setMembersTicketData(state, action) {
            devConsolelog('members ticket count', state, action.payload);
            const { count = 0, next = null, previous = null, results = {}, page = 0 } = action.payload;
            const { utilities = {}, open_close_system: membersTicketsList = [] } = results || {};
            devConsolelog('data in state memifowrgfwrgwrg', count);
            state.memData.count = count;
            state.memData.next = next;
            state.memData.previous = previous;
            state.memData.utilities = utilities;
            state.memData.membersTicketsList = membersTicketsList;
            state.memData.currentPage = page;
        },

        setAutosuggestData(state, action) {
            devConsolelog('auto suggest data ', state, action.payload);
            const {
                code__completion: memCodeData = [],
                company_name__completion: companyNameData = [],
                email__completion: emailData = [],
                name__completion: nameData = []
            } = action.payload;

            const autosuggestData = [
                memCodeData[0]?.options,
                nameData[0]?.options,
                companyNameData[0]?.options,
                emailData[0]?.options
            ].find((arr) => arr.length);

            const autosuggestDropdownData = autosuggestData.map((data) => {
                const { _source: source = {} } = data || {};
                const { name = '', code = '', email = '', company_name: companyName = '' } = source || {};

                return { code, name, email, companyName, label: `${code} | ${name} | ${email} | ${companyName}` };
            });

            state.autoSuggestData.dropdownData = autosuggestDropdownData;
        },

        setAcmAutosuggestData(state, action) {
            const { results = [] } = action.payload;

            const autosuggestData = [results].find((arr) => arr.length);
            devConsolelog('auto suggest acmdata ', autosuggestData);

            const autosuggestDropdownData = autosuggestData.map((data) => {
                const { id = '', first_name: firstName = '', last_name: lastName = '', email = '', username = '' } = data || {};

                return { firstName, lastName, email, username, id, label: `${id} | ${username} | ${email}` };
            });

            state.autoSuggestData.dropdownData = autosuggestDropdownData;
        },

        // Set data for selected ticket
        setTicketData(state, action) {
            devConsolelog('single ticket data in state mem', state, action.payload);
            const ticketData = action.payload;
            state.data.ticketData = ticketData;
        },

        setUpdatedTicketData(state, action) {
            devConsolelog('data in state updatedTicketData', action.payload, state.filters);
            state.postTicketData = action.payload;
            // state.data.currentPage = 0;
        },

        setFilters(state, action) {
            devConsolelog('data in state filters', action.payload, state.filters);
            state.filters = action.payload;
            // state.data.currentPage = 0;
        },

        setCurrentPage(state, action) {
            state.data.currentPage = action.payload;
        },

        setSelectedTicketData(state, action) {
            state.selectedTicketData = action.payload;
        },

        setIsLoading(state, action) {
            devConsolelog('isLoading', action.payload);
            state.isLoading = action.payload;
        },

        setCurrentPageUrl(state, action) {
            state.data.currentPageUrl = action.payload;
        },

        setClearTicketsData(state) {
            state.data.ticketsList = [];
        }
    }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getOpenCloseTicketsData(pageChangeUrl = '', filterType = '', newPage = 0) {
    return async () => {
        devConsolelog('getOpenCloseTicketsData url from params', pageChangeUrl, filterType, newPage);
        let url = `${ARYABHATTA_API_DOMAIN_V1}acm/oc-system/`;
        if (pageChangeUrl) {
            url = pageChangeUrl;
            if (newPage !== 0) dispatch(slice.actions.setCurrentPageUrl(pageChangeUrl));
        }
        if (filterType) {
            const finalFilterQueryString = filterQueryString(filterType);
            devConsolelog('filter url', finalFilterQueryString, filterType);
            url = `${url}?${finalFilterQueryString}`;
            if (newPage === 0) dispatch(slice.actions.setCurrentPageUrl(url));
        }
        try {
            const response = await axios.get(url, {
                headers: {
                    // Authorization: authHardcodedToken,
                    source: 'mweb'
                }
            });
            devConsolelog('response getOpenCloseTicketsData', response);
            dispatch(slice.actions.setData({ ...response.data, page: filterType ? 0 : newPage }));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            dispatch(slice.actions.setClearTicketsData());
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
        }
    };
}

export function getIndividualTicketData(ticketId = '') {
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}acm/oc-system/${ticketId}`;
        try {
            const response = await axios.get(url, {
                headers: {
                    // Authorization: authHardcodedToken,
                    source: 'mweb'
                }
            });
            devConsolelog('response ticket id', response.data);
            dispatch(slice.actions.setSelectedTicketData({ ...response.data }));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
        }
    };
}

export function getIndividualMembersTicketsData(memberCode = '', filterType = '', newPage = 0) {
    return async () => {
        devConsolelog('getOpenCloseTicketsData url from params', memberCode, filterType);
        // let url = `${ARYABHATTA_API_DOMAIN_V1}acm/members?ordering=-created_at`;
        const url = `${ARYABHATTA_API_DOMAIN_V1}acm/oc-system/?member=${memberCode}`;
        try {
            const response = await axios.get(url, {
                headers: {
                    // Authorization: authHardcodedToken,
                    source: 'mweb'
                }
            });
            devConsolelog('response getOpenCloseMembersTicketsData', response.data);
            dispatch(slice.actions.setMembersTicketData({ ...response.data, page: newPage || 0 }));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
        }
    };
}

export function getMemberAutosuggestData(searchedVal = '') {
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}acm/member/suggest?code__completion=${searchedVal}&company_name__completion=${searchedVal}&name__completion=${searchedVal}&email__completion=${searchedVal}`;
        try {
            const response = await axios.get(url, {
                headers: {
                    // Authorization: authHardcodedToken,
                    source: 'mweb'
                }
            });
            devConsolelog('response getMemberAutosuggestData', response.data);
            dispatch(slice.actions.setAutosuggestData({ ...response.data }));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getOrgAutosuggestData(searchedVal = '') {
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}organization/suggest?code__completion=${searchedVal}`;
        try {
            const response = await axios.get(url, {
                headers: {
                    // Authorization: authHardcodedToken,
                    source: 'mweb'
                }
            });
            devConsolelog('response getOrgAutosuggestData', response.data);
            dispatch(slice.actions.setAutosuggestData({ ...response.data }));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getAcmAutoSuggestData(searchedVal = '') {
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}acm/users/?search=${searchedVal}`;
        try {
            const response = await axios.get(url, {
                headers: {
                    // Authorization: authHardcodedToken,
                    source: 'mweb'
                }
            });
            devConsolelog('response getAcmAutoSuggestData', response.data);
            dispatch(slice.actions.setAcmAutosuggestData({ ...response.data }));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getSelectedObject(selectedObject) {
    return () => {
        devConsolelog('setSelectedTicketData', selectedObject);
        dispatch(slice.actions.setSelectedTicketData({ ...selectedObject }));
    };
}

export const setLoadingState =
    (isLoading = false) =>
    async () => {
        dispatch(slice.actions.setIsLoading(isLoading));
    };

export function patchCurrentTicketData(ticketId, updatedTicketData) {
    return async () => {
        devConsolelog('ticketId from params', ticketId, updatedTicketData);
        // let url = `${ARYABHATTA_API_DOMAIN_V1}acm/members?ordering=-created_at`;
        const url = `${ARYABHATTA_API_DOMAIN_V1}acm/oc-system/${ticketId}/
        `;
        try {
            const response = await axios.patch(url, updatedTicketData, {
                headers: {
                    // Authorization: authHardcodedToken,
                    source: 'mweb'
                }
            });
            devConsolelog('response editTicketData', response.data);
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
        }
    };
}

export function postCreateTicketData(updatedTicketData) {
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}acm/oc-system/?status=open/
        `;
        try {
            const response = await axios.post(url, updatedTicketData, {
                headers: {
                    // Authorization: authHardcodedToken,
                    source: 'mweb'
                }
            });
            devConsolelog('response editTicketData', response.data);
            dispatch(
                openSnackbar({
                    open: true,
                    message: `New Ticket Created.`,
                    variant: 'alert',
                    alert: {
                        color: 'success'
                    },
                    close: false
                })
            );
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
        }
    };
}

export const filterOCData =
    (filter = '') =>
    async () => {
        devConsolelog('in filters123', filter);
        dispatch(slice.actions.setFilters(filter || initialState.filters));
    };

export const setTicketData =
    (updatedTicketData = {}) =>
    async () => {
        devConsolelog('in updatedTicketData', updatedTicketData);
        dispatch(slice.actions.setUpdatedTicketData(updatedTicketData || initialState.postTicketData));
    };
